module.exports = __webpack_public_path__ + "static/media/PWA.8577bcee.png";